import {
  CareJourneySection,
  CareModeProvider,
  CareModesSection,
  CompanionsSection,
  FooterSection,
  HeaderSection,
  HeroSection,
  ServicesSection,
  StickyCallDock,
  TrustSection,
  VisitSection,
} from './features/clinic';
import { DemoPreviewBanner } from './shared/components/DemoPreviewBanner';
import { JmrSquaredAttribution } from './shared/components/JmrSquaredAttribution';
import { useInitialHashScroll } from './shared/hooks/useInitialHashScroll';

export function App() {
  useInitialHashScroll();

  return (
    <CareModeProvider>
      <div className="min-h-screen overflow-x-clip bg-surface text-ink">
        <DemoPreviewBanner />
        <HeaderSection />
        <main>
          <HeroSection />
          <CareJourneySection />
          <CareModesSection />
          <ServicesSection />
          <CompanionsSection />
          <TrustSection />
          <VisitSection />
          <FooterSection />
        </main>
        <StickyCallDock />
        <JmrSquaredAttribution />
      </div>
    </CareModeProvider>
  );
}
